__turbopack_context__.v({
  "className": "smooch_e9d80139-module__Jt0kIq__className",
});
